import React, { useState, useEffect } from "react";
import img1 from "../../assets/images/Odoo/Testmonial/ankit-nayak.png";
import img2 from "../../assets/images/Odoo/Testmonial/ankit-panchal.png";
import img3 from "../../assets/images/Odoo/Testmonial/jay-padaliya.png";
import img4 from "../../assets/images/Odoo/Testmonial/shailesh-prajapati.png";
import "./testi.css";
import { motion, AnimatePresence } from "framer-motion";

function Carousel2() {
const [index, setIndex] = useState(0);

const testimonials = [
{
img: img2,
text: "Nice place | Nice work | Good employee | Best company",
name: "Ankit Panchal",
},
{
img: img1,
text: "Solution for corporate branding & online marketing",
name: "Ankit Nayak",
},
{
img: img4,
text: "One stop solution for IT.",
name: "Shailesh Prajapati",
},

{
img: img3,
name: "Jay Padaliya",
text: "This place for alibaba minisite and phone application and wesite and more and here also good place for job",
},

];

// Auto-slide every 4 seconds
useEffect(() => {
const interval = setInterval(
() => setIndex((prev) => (prev + 1) % testimonials.length),
4000
);
return () => clearInterval(interval);
}, [testimonials.length]);

const fadeVariant = {
hidden: { opacity: 0, y: 50 },
visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
exit: { opacity: 0, y: -50, transition: { duration: 0.5 } },
};

return ( <div className="carousel2-container">
<motion.h2
initial={{ opacity: 0, y: -30 }}
animate={{ opacity: 1, y: 0 }}
transition={{ duration: 0.7 }}
className="carousel2-heading"
>
<span className="highlight-red">Testimonials</span>
</motion.h2>
<motion.p
initial={{ opacity: 0, y: -20 }}
animate={{ opacity: 1, y: 0 }}
transition={{ duration: 0.7, delay: 0.2 }}
className="carousel2-subheading"
>
Hear from Our Clients
</motion.p>
  <div className="carousel2-main">
    <AnimatePresence mode="wait">
      <motion.div
        key={index}
        className="carousel2-card"
        variants={fadeVariant}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <img
          src={testimonials[index].img}
          alt={testimonials[index].name}
          className="carousel2-avatar"
        />
        <p className="carousel2-text-content">"{testimonials[index].text}"</p>
        <h3 className="carousel2-text-name">{testimonials[index].name}</h3>
        <h5 className="carousel2-text-position">{testimonials[index].position}</h5>
      </motion.div>
    </AnimatePresence>

    <div className="carousel2-indicators">
      {testimonials.map((_, i) => (
        <button
          key={i}
          onClick={() => setIndex(i)}
          className={`carousel2-indicator ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  </div>
</div>

);
}

export default Carousel2;
